module.exports = __webpack_public_path__ + "img/Material of Shelves.e6da4681.svg";